export default "__VITE_ASSET__Dn67Eddf__"